import { create } from 'zustand';
import { getAreasByCity } from '../api/providerApi';

const useAreaStore = create((set) => ({
    areas: [],
    loading: false,
    error: null,

    fetchAreas: async (cityId) => {
        if (!cityId) {
            set({ areas: [] });
            return;
        }

        set({ loading: true, error: null });

        try {
            const data = await getAreasByCity(cityId);
            set({ areas: data, loading: false });
        } catch (err) {
            set({
                error: err.message || 'Failed to load areas',
                loading: false,
            });
        }
    },

    clearAreas: () => set({ areas: [] }),
}));

export default useAreaStore;
